module.exports = __webpack_public_path__ + "img/slider-1.d15dde60.png";